<script setup lang="ts">
/**
 * Error page for `ErrorCode.InvalidIssInAuthResponse` — the `iss` parameter
 * in the OAuth callback did not match the configured Keycloak issuer URL,
 * indicating a possible issuer-confusion attack or misconfiguration. Delegates
 * all rendering to `AuthErrorView`.
 */
import AuthErrorView from '@/components/errors/AuthErrorView.vue'
import { ErrorCode } from '@/errors/codes'
</script>

<template>
  <AuthErrorView :code="ErrorCode.InvalidIssInAuthResponse" />
</template>
